// Header/global search interaction layer.
//
// IMPORTANT: This file intentionally keeps the existing backend flow untouched:
//  - Suggestions endpoint: /inc/ajax/search-suggestions.asp
//  - Query param name: search-string
//  - CSRF token param: csrf-token
//  - Form submit remains native POST via the existing search form markup
//
// The UI now supports grouped rendering so we can plug in richer suggestion groups
// (categories / gift ideas / locations) later without changing the backend contract.

$(document).ready(function () {
  const recentSearchesKey = 'recentSearches';
  const popularSearchesCacheKey = 'popularSearchesCache';
  const maxSearchTagLength = 20;
  const maxRecentViewedDesktopItems = 4;
  const maxRecentViewedMobileItems = 3;
  const popularSearches = [
    { label: 'Pamper', url: '/pampering/' },
    { label: 'Days Out', url: '/things-to-do/' },
    { label: 'Afternoon Tea', url: '/gourmet/' },
    { label: 'Formula Ford', url: '/formula-ford/' }
  ];
  const recentlyViewedKey = 'recentlyViewedProducts';
  let cachedPopularSearches = null;
  let popularSearchesRequest = null;
  let ignoreNextDocumentClick = false;

  function getDesktopSearchHeader($form) {
    return $form.closest('.desktop-search-header');
  }

  function closeMoreMenu() {
    $('.more-menu').removeClass('open').children('.parent-title').attr('aria-expanded', 'false');
  }

  function isTabletViewport() {
      return window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches;
    }

  function closeMobileMenuDrawer() {
    $('.mobile-menu-drawer').removeClass('is-open').attr('aria-hidden', 'true');
    $('.mobile-menu-toggle').attr('aria-expanded', 'false');
    $('body').removeClass('mobile-menu-open');
    showMobileMenuDrawerView('root');
  }

  function showMobileMenuDrawerView(viewName) {
    const activeView = viewName || 'root';

    $('.mobile-menu-drawer__view').removeClass('is-active').attr('aria-hidden', 'true');
    $('.mobile-menu-drawer__view[data-mobile-menu-view="' + activeView + '"]')
      .addClass('is-active')
      .attr('aria-hidden', 'false');
  }

  function openMobileMenuDrawer() {
    if (!isNonDesktopViewport()) {
      return;
    }

    closeDesktopSearchPanel();
    $('.search-active').removeClass('is-open show-suggestions').hide();
    closeAllSuggestions();
    closeMoreMenu();
    showMobileMenuDrawerView('root');

    $('.mobile-menu-drawer').addClass('is-open').attr('aria-hidden', 'false');
    $('.mobile-menu-toggle').attr('aria-expanded', 'true');
    $('body').addClass('mobile-menu-open');
  }

  function openSearchPanel() {
    closeMobileMenuDrawer();

    if (isNonDesktopViewport()) {
      const $mobileSearch = $('.search-active').first();
      const $mobileForm = $mobileSearch.find('.js-global-search').first();

      if (!$mobileSearch.length || !$mobileForm.length) {
        return;
      }

      closeDesktopSearchPanel();
      $mobileSearch.addClass('is-open').show();
      displayRecentSuggestions($mobileForm);

      const $mobileInput = $mobileForm.find('input[name="search-string"]').first();
      if ($mobileInput.length) {
        $mobileInput.trigger('focus');
      }

      syncMobileSearchOverlayState();
      return;
    }

    const $desktopHeader = $('.desktop-search-header').first();
    if (!$desktopHeader.length) {
      return;
    }

    const $desktopPanelForm = $desktopHeader.find('.global-search-form-desktop-panel');
    openDesktopSearchPanel($desktopPanelForm);
    renderDesktopPanelLists($desktopHeader);
    syncMobileSearchOverlayState();

    const $desktopInput = $desktopPanelForm.find('input[name="search-string"]').first();
    if ($desktopInput.length) {
      $desktopInput.trigger('focus');
    }
  }

  function readPopularSearchesFromDom($scope) {
    const popularItems = [];

    ($scope && $scope.length ? $scope : $(document)).find('.js-search-popular-data .js-search-popular-item').slice(0, 4).each(function () {
      const $item = $(this);
      popularItems.push({
        label: $.trim($item.text()),
        url: $item.attr('href')
      });
    });

    return popularItems;
  }

  function getCachedPopularSearches() {
    if (cachedPopularSearches && cachedPopularSearches.length) {
      return cachedPopularSearches;
    }

    try {
      const storedPopularSearches = sessionStorage.getItem(popularSearchesCacheKey);
      if (storedPopularSearches) {
        cachedPopularSearches = JSON.parse(storedPopularSearches);
      }
    } catch (e) {
      cachedPopularSearches = null;
    }

    return Array.isArray(cachedPopularSearches) ? cachedPopularSearches : null;
  }

  function setCachedPopularSearches(items) {
    if (!Array.isArray(items) || !items.length) {
      return;
    }

    cachedPopularSearches = items.slice(0, 4);

    try {
      sessionStorage.setItem(popularSearchesCacheKey, JSON.stringify(cachedPopularSearches));
    } catch (e) {
      // ignore storage failures
    }
  }

  function ensurePopularSearchesLoaded(callback) {
    const domPopularSearches = readPopularSearchesFromDom($(document));
    if (domPopularSearches.length) {
      setCachedPopularSearches(domPopularSearches);
      if (callback) {
        callback(domPopularSearches);
      }
      return;
    }

    const storedPopularSearches = getCachedPopularSearches();
    if (storedPopularSearches && storedPopularSearches.length) {
      if (callback) {
        callback(storedPopularSearches);
      }
      return;
    }

    // A provisional category visit must not fetch the homepage merely to fill
    // this panel: that background request would promote an otherwise one-hit
    // visitor. The local defaults are sufficient until the next navigation.
    if (window.categorySessionDeferred) {
      if (callback) {
        callback(popularSearches);
      }
      return;
    }

    if (!popularSearchesRequest) {
      popularSearchesRequest = $.get('/', function (html) {
        const $markup = $('<div></div>').append($.parseHTML(html));
        const homepagePopularSearches = readPopularSearchesFromDom($markup);

        if (homepagePopularSearches.length) {
          setCachedPopularSearches(homepagePopularSearches);
        }
      }).always(function () {
        popularSearchesRequest = null;
      });
    }

    popularSearchesRequest.done(function () {
      const refreshedPopularSearches = getCachedPopularSearches();
      if (callback && refreshedPopularSearches && refreshedPopularSearches.length) {
        callback(refreshedPopularSearches);
      }
    });
  }

  function getPopularSearches() {
    const popularItems = readPopularSearchesFromDom($(document));

    if (popularItems.length) {
      setCachedPopularSearches(popularItems);
      return popularItems;
    }

    const storedPopularSearches = getCachedPopularSearches();
    if (storedPopularSearches && storedPopularSearches.length) {
      return storedPopularSearches;
    }

    return popularSearches;
  }

  function getRecentItemHref(item) {
    if (!item) {
      return '#';
    }

    const hrefKey = Object.keys(item).find(function (key) {
      return /^(producturl|productlink|url|link)$/i.test(key);
    });

    return hrefKey && item[hrefKey] ? item[hrefKey] : '#';
  }

  function getProductImagePath(item) {
    if (!item) {
      return '';
    }

    return String(item.productImageSmallPath || item.ProductImageSmallPath || item.productimagesmallpath || item.image || item.imageUrl || item.thumb || '');
  }

  function getItemProductName(item) {
    if (!item) {
      return '';
    }

    return String(item.productName || item.ProductName || item.name || item.label || item.suggestion || '');
  }

  function getStoredSearchItems(storageKey) {
    try {
      const storedItems = localStorage.getItem(storageKey);
      const parsedItems = storedItems ? JSON.parse(storedItems) : [];

      return Array.isArray(parsedItems) ? parsedItems : [];
    } catch (e) {
      return [];
    }
  }

  function getRecentSearches() {
    const recentSearches = getStoredSearchItems(recentSearchesKey);
    const displayableRecentSearches = getDisplayableRecentSearches(recentSearches);

    if (displayableRecentSearches.length !== recentSearches.length) {
      localStorage.setItem(recentSearchesKey, JSON.stringify(displayableRecentSearches));
    }

    return displayableRecentSearches;
  }

  function hasRecentSearchImage(item) {
    return $.trim(String(item && item.productImageSmallPath ? item.productImageSmallPath : '')) !== '';
  }

  function getDisplayableRecentSearches(items) {
    return (items || []).filter(function (item) {
      return hasRecentSearchImage(item);
    });
  }

  function getRecentlyViewedProducts() {
    return getStoredSearchItems(recentlyViewedKey);
  }

  function getRecentSearchCardLimit() {
    return isNonDesktopViewport() ? maxRecentViewedMobileItems : maxRecentViewedDesktopItems;
  }

  function getSearchTagUrl(searchTerm) {
    const normalizedSearchTerm = $.trim(String(searchTerm || ''))
      .replace(/,/g, '')
      .replace(/\s+/g, ' ')
      .replace(/ /g, '-');

    return normalizedSearchTerm ? '/search/' + encodeURIComponent(normalizedSearchTerm) + '/' : '#';
  }

  function truncateSearchTagLabel(searchTerm) {
    const normalizedSearchTerm = $.trim(String(searchTerm || ''));

    if (normalizedSearchTerm.length <= maxSearchTagLength) {
      return normalizedSearchTerm;
    }

    return normalizedSearchTerm.slice(0, maxSearchTagLength - 3) + '...';
  }

  function renderRecentSearchTags(items, $context) {
    const recentItems = (items || []).filter(function (item) {
      return $.trim(String(item && item.searchTerm ? item.searchTerm : '')) !== '';
    });

    if (!recentItems.length) {
      return null;
    }

    const $tagsToolbar = $('<div class="search-tags-toolbar"></div>');
    const $tags = $('<div class="search-tags"></div>');
    const $clearAll = $('<button type="button" class="search-tags-clear">Clear all</button>');

    recentItems.forEach(function (item) {
      const searchTerm = $.trim(String(item.searchTerm || ''));
      const tagUrl = getSearchTagUrl(searchTerm);

      if (!searchTerm || tagUrl === '#') {
        return;
      }

      $tags.append(
        $('<a></a>')
          .addClass('search-tag')
          .attr('href', tagUrl)
          .attr('title', searchTerm)
          .attr('aria-label', searchTerm)
          .text(truncateSearchTagLabel(searchTerm))
      );
    });

    if (!$tags.children().length) {
      return null;
    }

    $clearAll.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearRecentSearches();

      if ($context && $context.length) {
        if ($context.hasClass('desktop-search-header')) {
          renderDesktopPanelLists($context);
        } else {
          displayRecentSuggestions($context);
        }
      }
    });

    $tagsToolbar.append($tags, $clearAll);

    return $tagsToolbar;
  }

  function renderSectionHeader(title, actionText, actionHandler) {
    const $header = $('<div class="suggestions-section-header"></div>');
    $header.append($('<p class="suggestions-section-title"></p>').text(title));

    if (actionText && typeof actionHandler === 'function') {
      const $action = $('<button type="button" class="suggestions-section-action"></button>').text(actionText);
      $action.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        actionHandler();
      });
      $header.append($action);
    }

    return $header;
  }

  function findRecentSearchProductMeta(item, recentlyViewedItems) {
    const recentHref = getRecentItemHref(item);
    const recentSearchTerm = String(item && item.searchTerm ? item.searchTerm : '').toLowerCase();
    const recentPlaceName = String(item && item.placeName ? item.placeName : '').toLowerCase();

    return (recentlyViewedItems || []).find(function (viewedItem) {
      const viewedHref = getRecentItemHref(viewedItem);
      const viewedName = String(viewedItem.productName || viewedItem.ProductName || viewedItem.name || viewedItem.label || viewedItem.searchTerm || '').toLowerCase();
      const viewedPlaceName = String(viewedItem.placeName || viewedItem.PlaceName || viewedItem.placename || '').toLowerCase();

      if (recentHref !== '#' && viewedHref === recentHref) {
        return true;
      }

      return recentSearchTerm && viewedName === recentSearchTerm && (!recentPlaceName || !viewedPlaceName || viewedPlaceName === recentPlaceName);
    }) || null;
  }

  function renderRecentSearchCard(item, recentlyViewedItems, $form) {
    const href = getRecentItemHref(item);
    const matchedProduct = findRecentSearchProductMeta(item, recentlyViewedItems);
    const productName = item.productName || getItemProductName(matchedProduct);
    const title = productName || item.searchTerm || item.name || '';
    const searchTerm = item.searchTerm || title;
    const placeName = item.placeName || item.PlaceName || item.placename || '';
    const productImagePath = getProductImagePath(item) || getProductImagePath(matchedProduct);
    const productImage = getSearchProductImageUrl(productImagePath);
    const $card = $('<a></a>')
      .addClass('suggestions-product-card suggestions-product-card--mini')
      .attr('href', href);
    const $cardBody = $('<span></span>').addClass('suggestions-product-card__body');

    if (productImage) {
      $card.append(createSearchProductImageElement(productImage, title));
    }

    if (placeName) {
      $cardBody.append($('<span></span>').addClass('suggestions-product-card__location').text(placeName));
    }

    $cardBody.append($('<span></span>').addClass('suggestions-product-card__title').text(title));
    $card.append($cardBody);

    $card.on('click', function (e) {
      storeRecentSearch(searchTerm, href, placeName, productImagePath, title);

      if (href === '#') {
        e.preventDefault();
        $form.find('input[name="search-string"]').val(searchTerm);
        syncDesktopSearchInputs($form.find('input[name="search-string"]'));
        $form.submit();
      }
    });

    return $card;
  }

  $('.global-search-form-desktop input[name="search-string"]').on('focus click', function () {
    const $input = $(this);
    const $header = $input.closest('.desktop-search-header');
    const $panelInput = $header.find('.global-search-form-desktop-panel input[name="search-string"]');

    if (isTabletViewport()) {
      const $mobileSearch = $('.search-active');
      const $mobileForm = $mobileSearch.find('.js-global-search').first();
      const $mobileInput = $mobileForm.find('input[name="search-string"]').first();

      ignoreNextDocumentClick = true;
      closeDesktopSearchPanel($header);
      $mobileInput.val($input.val());
      showMobileSearchPanel($mobileForm);

      if ($mobileInput.val().trim() === '') {
        displayRecentSuggestions($mobileForm);
        ensurePopularSearchesLoaded(function () {
          displayRecentSuggestions($mobileForm);
        });
      }

      setTimeout(function () {
        $mobileInput.trigger('focus');
      }, 0);

      return;
    }

    openDesktopSearchPanel($header.find('.global-search-form-desktop-panel'));
    renderDesktopPanelLists($header);
    ensurePopularSearchesLoaded(function () {
      renderDesktopPanelLists($header);
    });
    $panelInput.val($input.val());

    setTimeout(function () {
      $panelInput.trigger('focus');
    }, 0);
  });

  $('.global-search-form-desktop').on('submit', function (e) {
    e.preventDefault();
    const $header = $(this).closest('.desktop-search-header');
    const $panelForm = $header.find('.global-search-form-desktop-panel');
    const $panelInput = $panelForm.find('input[name="search-string"]');

    if (isTabletViewport()) {
      const $mobileForm = $('.search-active .js-global-search').first();
      const $mobileInput = $mobileForm.find('input[name="search-string"]').first();

      $mobileInput.val($(this).find('input[name="search-string"]').val());
      showMobileSearchPanel($mobileForm);
      $mobileForm.submit();
      return;
    }

    $panelInput.val($(this).find('input[name="search-string"]').val());
    $panelForm.submit();
  });

  $(document).on('click', '.more-menu > .parent-title', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $menu = $(this).closest('.more-menu');
    const isOpen = $menu.hasClass('open');

    closeMoreMenu();

    if (!isOpen) {
      $menu.addClass('open');
      $(this).attr('aria-expanded', 'true');
    }
  });

  $(document).on('mouseenter', '.primary .navbar-nav > li:not(.more-menu)', function () {
    closeMoreMenu();
  });

  $(document).on('focusin', function (e) {
    if (!$(e.target).closest('.more-menu').length) {
      closeMoreMenu();
    }
  });

  $(document).on('click', '.mobile-menu-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(this).attr('aria-expanded') === 'true') {
      closeMobileMenuDrawer();
      return;
    }

    openMobileMenuDrawer();
  });

  $(document).on('click', '.mobile-menu-drawer__close', function (e) {
    e.preventDefault();
    closeMobileMenuDrawer();
  });

  $(document).on('click', '.js-mobile-menu-panel-trigger', function (e) {
    e.preventDefault();
    const targetView = $(this).attr('data-mobile-menu-target');

    if (!targetView) {
      return;
    }

    showMobileMenuDrawerView(targetView);
  });

  $(document).on('click', '.js-mobile-menu-back', function (e) {
    e.preventDefault();
    const targetView = $(this).attr('data-mobile-menu-back-target') || 'root';
    showMobileMenuDrawerView(targetView);
  });

  $(document).on('click', '.mobile-menu-drawer', function (e) {
    if ($(e.target).is('.mobile-menu-drawer')) {
      closeMobileMenuDrawer();
    }
  });

  function syncDesktopSearchInputs($sourceInput) {
    const value = $sourceInput.val();
    const $header = $sourceInput.closest('.desktop-search-header');

    if (!$header.length) {
      return;
    }

    $header.find('input[name="search-string"]').not($sourceInput).val(value);
  }

  function openDesktopSearchPanel($form) {
    if (isTabletViewport()) {
      return;
    }

    const $header = getDesktopSearchHeader($form);
    if (!$header.length) {
      return;
    }

    $header.addClass('is-open');
    $header.find('.desktop-search-panel').attr('aria-hidden', 'false');
  }

  function closeDesktopSearchPanel($scope) {
    const $headers = $scope && $scope.length ? $scope : $('.desktop-search-header');

    $headers.removeClass('is-open');
    $headers.removeClass('show-suggestions');
    $headers.find('.desktop-search-panel').attr('aria-hidden', 'true');
    $headers.find('.suggestions-container').hide().empty();
    $headers.find('.js-search-suggestions-column').empty();
    $headers.find('.js-search-products-column').empty();
    $headers.find('.desktop-search-panel__actions').hide();
  }

  function renderDesktopPanelLists($header) {
    if (!$header.length) {
      return;
    }

    const $popularList = $header.find('.desktop-search-panel__popular-list');
    const $recentList = $header.find('.desktop-search-panel__recent-list');
    const activePopularSearches = getPopularSearches();
    const recentSearches = getDisplayableRecentSearches(getRecentSearches());
    const recentlyViewed = getRecentlyViewedProducts();
    const $panelForm = $header.find('.global-search-form-desktop-panel');

    $popularList.empty();
    activePopularSearches.forEach(function (search) {
      const targetUrl = search.url ? search.url : '#';
      const $link = $('<a></a>').attr('href', targetUrl).text(search.label);
      $link.on('click', function (e) {
        storeRecentSearch(search.label, search.url, '');

        if (search.url) {
          window.location.href = search.url;
          return;
        }

        e.preventDefault();
        const $input = $header.find('.global-search-form-desktop-panel input[name="search-string"]');
        $input.val(search.label);
        syncDesktopSearchInputs($input);
        $header.find('.global-search-form-desktop-panel').submit();
      });
      $popularList.append($link);
    });

    $recentList.empty();
    if (recentSearches.length) {
      const $recentTags = renderRecentSearchTags(recentSearches, $header);
      const $recentCards = $('<div class="suggestions-product-cards"></div>');

      if ($recentTags) {
        $recentList.append($recentTags);
      }

      recentSearches.slice(0, getRecentSearchCardLimit()).forEach(function (item) {
        $recentCards.append(renderRecentSearchCard(item, recentlyViewed, $panelForm));
      });

      $recentList.append($recentCards);
    } else {
      $recentList.append('<div class="desktop-search-panel__empty">Your recently viewed items will appear here.</div>');
    }
  }

  function closeSuggestions($form) {
    const $header = getDesktopSearchHeader($form);

    if (isDesktopSearchPanelForm($form) && $.trim($form.find('input[name="search-string"]').val()) !== '') {
      $header.removeClass('show-suggestions');
      $header.find('.js-search-suggestions-column').empty();
      $header.find('.js-search-products-column').empty();
      $header.find('.desktop-search-panel__actions').hide();
      renderDesktopPanelLists($header);
      syncMobileSearchOverlayState();
      return;
    }

    $form.find('.suggestions-container').hide().empty();
    $form.closest('.search-active').removeClass('show-suggestions');
    $header.removeClass('show-suggestions');
    $header.find('.js-search-suggestions-column').empty();
    $header.find('.js-search-products-column').empty();
    $header.find('.desktop-search-panel__actions').hide();

    if ($form.closest('.desktop-search-panel__bar').length) {
      renderDesktopPanelLists($header);
    }

    syncMobileSearchOverlayState();
  }

  function isDesktopSearchPanelForm($form) {
    return $form.closest('.desktop-search-panel__bar').length > 0;
  }

  function getDesktopSearchPanelColumns($form) {
    const $header = getDesktopSearchHeader($form);

    return {
      $header: $header,
      $suggestions: $header.find('.js-search-suggestions-column'),
      $products: $header.find('.js-search-products-column')
    };
  }

  function closeAllSuggestions() {
    $('.js-global-search').each(function () {
      closeSuggestions($(this));
    });
  }

  // Capture before suggestion handlers replace the typed term or navigate.
  function logSearchAreaClick(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const $link = $(event.target).closest('a[href]');
    const $area = $link.closest('.desktop-search-panel__content, .suggestions-container');
    if (!$area.length) return;
    const $form = $area.hasClass('suggestions-container')
      ? $area.closest('form')
      : $area.closest('.desktop-search-header').find('.global-search-form-desktop-panel');
    const term = $.trim($form.find('input[name="search-string"]').val() || '');
    if (!term || !window.csrfToken) return;

    const body = 'term=' + encodeURIComponent(term) + '&csrf-token=' + encodeURIComponent(window.csrfToken);
    const endpoint = '/inc/ajax/search-click.aspx';
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(endpoint,
        new Blob([body], { type: 'application/x-www-form-urlencoded;charset=UTF-8' }))) return;
    } catch (error) {}
    if (window.fetch) {
      window.fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: body
      }).catch(function () {});
    }
  }
  document.addEventListener('click', logSearchAreaClick, true);
  document.addEventListener('auxclick', logSearchAreaClick, true);

  function storeRecentSearch(searchTerm, productUrl, placeName, productImagePath, productName) {
    const normalizedProductImagePath = $.trim(String(productImagePath || ''));

    if (!normalizedProductImagePath) {
      return;
    }

    let recentSearches = getRecentSearches();

    recentSearches = recentSearches.filter(search => search.searchTerm !== searchTerm && search.productUrl !== productUrl);
    recentSearches.unshift({
      searchTerm: searchTerm,
      productUrl: productUrl,
      placeName: placeName,
      productImageSmallPath: normalizedProductImagePath,
      productName: productName || ''
    });

    while (recentSearches.length > maxRecentViewedDesktopItems) {
      recentSearches.pop();
    }

    localStorage.setItem(recentSearchesKey, JSON.stringify(recentSearches));
  }

  function removeRecentSearch(searchTerm) {
    let recentSearches = getRecentSearches();
    recentSearches = recentSearches.filter(item => item.searchTerm !== searchTerm);
    localStorage.setItem(recentSearchesKey, JSON.stringify(recentSearches));
  }

  function clearRecentSearches() {
    localStorage.removeItem(recentSearchesKey);
  }

  function getMetaPropertyContent(propertyName) {
    const $metaTag = $('meta[property="' + propertyName + '"]').first();

    if (!$metaTag.length) {
      return '';
    }

    return $.trim(String($metaTag.attr('content') || ''));
  }

  function normalizeRecentSearchUrl(url) {
    const normalizedUrl = $.trim(String(url || ''));

    if (!normalizedUrl) {
      return '';
    }

    try {
      const parsedUrl = new URL(normalizedUrl, window.location.origin);
      return (parsedUrl.pathname || '') + (parsedUrl.search || '') + (parsedUrl.hash || '');
    } catch (e) {
      return normalizedUrl.replace(/^https?:\/\/[^/]+/i, '');
    }
  }

  function normalizeRecentSearchImagePath(imagePath) {
    const normalizedImagePath = $.trim(String(imagePath || ''));

    if (!normalizedImagePath) {
      return '';
    }

    try {
      const parsedUrl = new URL(normalizedImagePath, window.location.origin);
      const pathSegments = (parsedUrl.pathname || '').split('/').filter(Boolean);
      return pathSegments.length ? pathSegments[pathSegments.length - 1] : '';
    } catch (e) {
      const pathWithoutQuery = normalizedImagePath.split('?')[0].split('#')[0];
      const pathSegments = pathWithoutQuery.split('/').filter(Boolean);
      return pathSegments.length ? pathSegments[pathSegments.length - 1] : pathWithoutQuery;
    }
  }

  function syncRecentSearchFromProductMeta() {
    const ogType = getMetaPropertyContent('og:type').toLowerCase();
    const productUrl = normalizeRecentSearchUrl(getMetaPropertyContent('og:url'));
    const productName = getMetaPropertyContent('og:title');
    const productImage = normalizeRecentSearchImagePath(getMetaPropertyContent('og:image'));
    const placeName = getMetaPropertyContent('te:location');

    if (ogType !== 'product' || !productUrl || !productName || !productImage) {
      return;
    }

    storeRecentSearch(productName, productUrl, placeName, productImage, productName);
  }

  function getGroupKey(item) {
    // Backend is currently flat. This helper lets us map future payload group metadata
    // into grouped UI without changing display code.
    if (item.group) {
      return item.group;
    }

    if (item.producturl) {
      return 'matching-experiences';
    }

    if (item.placename) {
      return 'locations';
    }

    return 'gift-ideas';
  }

  function appendHighlightedSuggestionTitle($title, suggestionText, keyedTerm) {
    const normalizedKeyedTerm = $.trim(String(keyedTerm || '')).toLowerCase();
    const suggestionValue = String(suggestionText || '');

    if (!normalizedKeyedTerm) {
      $title.text(suggestionValue);
      return;
    }

    let currentIndex = 0;
    let matchIndex = suggestionValue.toLowerCase().indexOf(normalizedKeyedTerm);

    if (matchIndex === -1) {
      $title.text(suggestionValue);
      return;
    }

    while (matchIndex > -1) {
      if (matchIndex > currentIndex) {
        $title.append(document.createTextNode(suggestionValue.slice(currentIndex, matchIndex)));
      }

      $title.append(
        $('<strong></strong>').text(suggestionValue.slice(matchIndex, matchIndex + normalizedKeyedTerm.length))
      );

      currentIndex = matchIndex + normalizedKeyedTerm.length;
      matchIndex = suggestionValue.toLowerCase().indexOf(normalizedKeyedTerm, currentIndex);
    }

    if (currentIndex < suggestionValue.length) {
      $title.append(document.createTextNode(suggestionValue.slice(currentIndex)));
    }
  }

  function renderSection(title, className, items, $form) {
    if (!items.length) {
      return null;
    }

    const $section = $('<div class="suggestions-section"></div>');
    const keyedTerm = $.trim($form.find('input[name="search-string"]').val());

    if (!(isNonDesktopViewport() && title === 'Suggestions')) {
      $section.append(renderSectionHeader(title));
    }

    items.forEach(function (item) {
      const producturl = item.producturl ? item.producturl : '#';
      const suggestionText = item.suggestion ? item.suggestion : '';
      const $link = $('<a></a>').attr('href', producturl);
      const $content = $('<span class="suggestions-item__content"></span>');
      const $title = $('<span></span>').addClass('suggestions-item__title');

      appendHighlightedSuggestionTitle($title, suggestionText, keyedTerm);

      $content.append($title);

      $link.append($content);

      const $suggestionItem = $('<div></div>')
        .addClass('suggestions-item ' + className)
        .append($link);

      $suggestionItem.on('click', function () {
        $form.find('input[name="search-string"]').val(item.suggestion);
        storeRecentSearch(item.suggestion, item.producturl, item.placename, getProductImagePath(item), getItemProductName(item));
        $form.submit();
      });

      $section.append($suggestionItem);
    });

    return $section;
  }

  function getLimitedSuggestionSections(suggestions, $form, maxSuggestions) {
    const groups = {
      'matching-experiences': [],
      'categories': [],
      'gift-ideas': [],
      'locations': []
    };

    (suggestions || []).forEach(function (item) {
      const groupKey = getGroupKey(item);
      if (groups[groupKey]) {
        groups[groupKey].push(item);
      } else {
        groups['matching-experiences'].push(item);
      }
    });

    let remainingSuggestionSlots = maxSuggestions;

    return [
      { title: 'Suggestions', className: 'suggestions-item--experience', items: groups['matching-experiences'] },
      { title: 'Categories', className: 'suggestions-item--category', items: groups['categories'] },
      { title: 'Gift Ideas', className: 'suggestions-item--gift', items: groups['gift-ideas'] },
      { title: 'Locations', className: 'suggestions-item--location', items: groups['locations'] }
    ].map(function (section) {
      if (remainingSuggestionSlots <= 0) {
        return null;
      }

      const limitedItems = section.items.slice(0, remainingSuggestionSlots);
      remainingSuggestionSlots -= limitedItems.length;

      return renderSection(section.title, section.className, limitedItems, $form);
    });
  }

  function renderDesktopPanelSuggestions($form, data) {
    const panel = getDesktopSearchPanelColumns($form);
    const suggestions = Array.isArray(data) ? data : (data && Array.isArray(data.suggestions) ? data.suggestions : []);
    const popularProducts = data && Array.isArray(data.popularProducts) ? data.popularProducts : [];
    const cardProducts = getCardProducts(suggestions, popularProducts);
    const searchTerm = $.trim($form.find('input[name="search-string"]').val());
    const $seeAllActions = panel.$header.find('.desktop-search-panel__actions');
    const $seeAllLink = $seeAllActions.find('.js-search-see-all');

    panel.$suggestions.empty();
    panel.$products.empty();
    $seeAllActions.hide();
    $seeAllLink.off('click');

    if (!suggestions.length && !cardProducts.length) {
      panel.$suggestions.append('<div class="suggestions-empty">No suggestions found. Try another search term.</div>');
      panel.$header.addClass('show-suggestions');
      return;
    }

    const sections = getLimitedSuggestionSections(suggestions, $form, 5);

    sections.forEach(function ($section) {
      if ($section) {
        panel.$suggestions.append($section);
      }
    });

    if (!panel.$suggestions.children().length) {
      panel.$suggestions.append('<div class="suggestions-empty">No suggestions found. Try another search term.</div>');
    }

    const $productCardsSection = renderProductCardsSection(cardProducts);
    if ($productCardsSection) {
      panel.$products.append($productCardsSection);

      const ctaUrl = getCanonicalSearchResultsUrl(searchTerm);
      $seeAllLink.attr('href', ctaUrl);
      $seeAllLink.on('click', function (e) {
        e.preventDefault();
        if (searchTerm) {
          storeRecentSearch(searchTerm, ctaUrl, '');
        }
        window.location.href = ctaUrl;
      });
      $seeAllActions.show();
    }

    panel.$header.addClass('show-suggestions');
  }

  function renderEmptyState($container) {
    $container.append('<div class="suggestions-empty">No suggestions found. Try another search term.</div>');
  }

  function getCanonicalSearchResultsUrl(searchTerm) {
    return '/search.asp?search-string=' + encodeURIComponent(searchTerm || '');
  }

  function getSearchProductFallbackImageUrl() {
    const baseContentDomain = String(window.contentDomain || '').replace(/\/$/, '');
    return (baseContentDomain ? baseContentDomain : '') + '/content/product/220w/no-image-found.jpg';
  }

  function getSearchProductImageUrl(productImagePath) {
    const imagePath = String(productImagePath || '').replace(/^\/+/, '');

    if (!imagePath) {
      return getSearchProductFallbackImageUrl();
    }

    if (imagePath.indexOf('http://') === 0 || imagePath.indexOf('https://') === 0) {
      return imagePath;
    }

    const baseContentDomain = String(window.contentDomain || '').replace(/\/$/, '');
    return (baseContentDomain ? baseContentDomain : '') + '/content/product/220w/' + imagePath;
  }

  function createSearchProductImageElement(productImageUrl, altText) {
    const fallbackImageUrl = getSearchProductFallbackImageUrl();
    const resolvedImageUrl = String(productImageUrl || '').trim() || fallbackImageUrl;

    return $('<img>')
      .addClass('suggestions-product-card__image')
      .attr('src', resolvedImageUrl)
      .attr('alt', altText || '')
      .on('error', function () {
        if (this.src === fallbackImageUrl) {
          return;
        }

        this.src = fallbackImageUrl;
      });
  }

  function getSearchProductCardLimit() {
    return window.innerWidth >= 1200 ? 4 : 3;
  }

  function getActiveSearchTerm() {
    return $.trim($('.global-search-form-desktop-panel input[name="search-string"]').val()) ||
      $.trim($('.global-search-form-desktop input[name="search-string"]').val()) ||
      $.trim($('.js-global-search input[name="search-string"]').first().val());
  }

  function getCardProducts(suggestions, popularProducts) {
    const cardLimit = getSearchProductCardLimit();

    if (Array.isArray(popularProducts) && popularProducts.length) {
      return popularProducts.slice(0, cardLimit);
    }

    const matchingExperienceProducts = (suggestions || []).filter(function (item) {
      return item && item.producturl && !item.category;
    });

    return matchingExperienceProducts.slice(0, cardLimit);
  }

  function renderProductCardsSection(popularProducts) {
    // Keep this markup aligned with /inc/snippets/product-card-search-mini.inc for search panel usage.
    const products = (popularProducts || []).slice(0, getSearchProductCardLimit());
    if (!products.length) {
      return null;
    }

    const $section = $('<div class="suggestions-products-column"></div>');
    $section.append('<p class="suggestions-section-title">Popular Products Matching Your Search</p>');

    const $cards = $('<div class="suggestions-product-cards"></div>');

    products.forEach(function (product) {
      const productName = String(product.ProductName || product.productName || product.name || product.suggestion || '');
      const productUrl = String(product.ProductURL || product.productUrl || product.producturl || product.url || '#');
      const productImagePath = getProductImagePath(product);
      const productImage = getSearchProductImageUrl(productImagePath);
      const placeName = String(product.placeName || product.PlaceName || product.placename || '');
      const currentPrice = Number(product.currentPrice || product.CurrentPrice || product.price || 0);
      const displayPrice = currentPrice > 0 ? '$' + currentPrice.toFixed(0) : '';
      const avgRating = Number(product.avgRating || product.AvgRating || 0);
      const ratingCount = Number(product.ratingCount || product.RatingCount || 0);
      const hasRating = ratingCount > 0 && avgRating > 0;
      const isMobile = isNonDesktopViewport();
      const $card = $('<a></a>')
        .addClass('suggestions-product-card suggestions-product-card--mini')
        .attr('href', productUrl);
      const $cardBody = $('<span></span>').addClass('suggestions-product-card__body');
      const $cardTitle = $('<span></span>')
        .addClass('suggestions-product-card__title')
        .text(productName);

      if (productImage) {
        const $image = createSearchProductImageElement(productImage, productName);
        $card.append($image);
      }

      if (isMobile && (placeName || hasRating)) {
        const $topMetaRow = $('<span class="suggestions-product-card__top-meta"></span>');

        if (placeName) {
          $topMetaRow.append($('<span></span>').addClass('suggestions-product-card__location').text(placeName));
        }

        if (hasRating) {
          $topMetaRow.append($('<span></span>').addClass('suggestions-product-card__rating').text(avgRating.toFixed(1) + ' ★'));
        }

        $cardBody.append($topMetaRow);
      } else if (placeName) {
        $cardBody.append($('<span></span>').addClass('suggestions-product-card__location').text(placeName));
      }

      $cardBody.append($cardTitle);

      const $metaRow = $('<span class="suggestions-product-card__meta-row"></span>');
      if (displayPrice) {
        $metaRow.append($('<span class="suggestions-product-card__price"></span>').text(displayPrice));
      }
      if (!isMobile && hasRating) {
        $metaRow.append($('<span class="suggestions-product-card__rating"></span>').text(avgRating.toFixed(1) + ' ★ (' + ratingCount + ')'));
      }
      if ($metaRow.children().length) {
        $cardBody.append($metaRow);
      }

      $card.append($cardBody);
      $cards.append($card);
    });

    $section.append($cards);
    return $section;
  }

  function displayRecentSuggestions($form) {
    const $container = $form.find('.suggestions-container');
    $container.empty();

    const recentSearches = getDisplayableRecentSearches(getRecentSearches());
    const recentlyViewed = getRecentlyViewedProducts();
    const activePopularSearches = getPopularSearches();
    const showRecentTags = !isNonDesktopViewport();
    const $grid = $('<div class="suggestions-grid"></div>');
    const $popularSection = $('<div class="suggestions-section suggestions-section--popular"></div>');
    const $popularList = $('<div class="suggestions-popular-list"></div>');
    $popularSection.append(renderSectionHeader('Popular searches'));

    activePopularSearches.forEach(function (search) {
      const targetUrl = search.url ? search.url : '#';
      const $popularLink = $('<a class="suggestions-popular-link" href="#"></a>');
      $popularLink.attr('href', targetUrl).text(search.label);
      $popularLink.on('click', function (e) {
        storeRecentSearch(search.label, search.url, '');

        if (search.url) {
          window.location.href = search.url;
          return;
        }

        e.preventDefault();
        $form.find('input[name="search-string"]').val(search.label);
        $form.submit();
      });
      $popularList.append($popularLink);
    });

    $popularSection.append($popularList);

    const $recentSection = $('<div class="suggestions-section suggestions-section--recent"></div>');
    $recentSection.append(renderSectionHeader(
      'Recently Viewed',
      recentSearches.length ? 'Clear all' : '',
      function () {
        clearRecentSearches();
        displayRecentSuggestions($form);
      }
    ));

    if (recentSearches.length) {
      const $recentTags = renderRecentSearchTags(recentSearches, $form);
      const $recentCards = $('<div class="suggestions-product-cards"></div>');

      if ($recentTags && showRecentTags) {
        $recentSection.append($recentTags);
      }

      recentSearches.slice(0, getRecentSearchCardLimit()).forEach(function (search) {
        $recentCards.append(renderRecentSearchCard(search, recentlyViewed, $form));
      });

      $recentSection.append($recentCards);
    } else {
      $recentSection.append('<div class="suggestions-empty">Your recently viewed items will appear here.</div>');
    }

    $grid.append($popularSection).append($recentSection);
    $container.append($grid);
    $container.show();
    $form.closest('.search-active').addClass('show-suggestions');
    getDesktopSearchHeader($form).addClass('show-suggestions');
    syncMobileSearchOverlayState();
  }

  function displaySuggestions($form, data) {
    if (isDesktopSearchPanelForm($form)) {
      renderDesktopPanelSuggestions($form, data);
      return;
    }

    const $container = $form.find('.suggestions-container');
    $container.empty();

    const suggestions = Array.isArray(data) ? data : (data && Array.isArray(data.suggestions) ? data.suggestions : []);
    const popularProducts = data && Array.isArray(data.popularProducts) ? data.popularProducts : [];
    const cardProducts = getCardProducts(suggestions, popularProducts);
    const searchTerm = $.trim($form.find('input[name="search-string"]').val());

    if (!suggestions.length && !cardProducts.length) {
      renderEmptyState($container);
      $container.show();
      $form.closest('.search-active').addClass('show-suggestions');
      getDesktopSearchHeader($form).addClass('show-suggestions');
      syncMobileSearchOverlayState();
      return;
    }

    const $layout = $('<div class="suggestions-layout"></div>');
    const $leftColumn = $('<div class="suggestions-list-column"></div>');
    const $rightColumn = $('<div class="suggestions-products-column-wrap"></div>');
    let $footerCta = null;

    const sections = getLimitedSuggestionSections(suggestions, $form, 5);

    sections.forEach(function ($section) {
      if ($section) {
        $leftColumn.append($section);
      }
    });

    const $productCardsSection = renderProductCardsSection(cardProducts);
    if ($productCardsSection) {
      $rightColumn.append($productCardsSection);

      const ctaUrl = getCanonicalSearchResultsUrl(searchTerm);
      $footerCta = $('<div class="suggestions-footer"><a class="suggestions-footer__cta" href="' + ctaUrl + '">See all results</a></div>');
      $footerCta.find('a').on('click', function (e) {
        e.preventDefault();
        if (searchTerm) {
          storeRecentSearch(searchTerm, ctaUrl, '');
        }
        window.location.href = ctaUrl;
      });
    }

    if (!$leftColumn.children().length) {
      $leftColumn.append('<div class="suggestions-empty">No suggestions found. Try another search term.</div>');
    }

    $layout.append($leftColumn).append($rightColumn);
    $container.append($layout);
    if ($footerCta) {
      $container.append($footerCta);
    }

    $container.show();
    $form.closest('.search-active').addClass('show-suggestions');
    getDesktopSearchHeader($form).addClass('show-suggestions');
    syncMobileSearchOverlayState();
  }

  function hasStructuredSearchPayload(data) {
    return data && !Array.isArray(data) && Array.isArray(data.suggestions) && Array.isArray(data.popularProducts);
  }

  function renderPopularProducts($container, products, $form) {
    if (!products || !products.length) {
      return;
    }

    const $section = $('<div class="suggestions-section suggestions-section--products"></div>');
    $section.append('<p class="suggestions-section-title">Popular Products Matching Your Search</p>');

    products.forEach(function (product) {
      const productName = product.ProductName || product.productName || '';
      const productUrl = product.ProductURL || product.producturl || '#';
      const placeName = product.PlaceName || product.placename || '';
      const currentPrice = product.CurrentPrice || product.currentPrice;
      const ratingCount = product.RatingCount || product.ratingCount;
      const avgRating = product.AvgRating || product.avgRating;
      const badgeTag = product.BadgeTag || product.badgeTag;
      const priceText = (currentPrice || currentPrice === 0) ? 'From $' + currentPrice : '';
      const ratingText = (avgRating && ratingCount) ? ' · ' + avgRating + '★ (' + ratingCount + ')' : '';
      const metaText = [placeName, priceText].filter(Boolean).join(' · ') + ratingText;
      const badgeMarkup = badgeTag ? '<span class="suggestions-item-badge">' + badgeTag + '</span>' : '';
      const $item = $('<div class="suggestions-item suggestions-item--experience suggestions-item--product"><a href="' + productUrl + '"><strong>' + productName + '</strong><span class="suggestions-item-meta">' + metaText + '</span>' + badgeMarkup + '</a></div>');

      $section.append($item);
    });

    $container.append($section);
  }

  function displayStructuredSuggestions($form, payload) {
    if (isDesktopSearchPanelForm($form)) {
      renderDesktopPanelSuggestions($form, payload);
      return;
    }

    displaySuggestions($form, payload);
  }

  syncRecentSearchFromProductMeta();

  $('.js-global-search').each(function () {
    const $form = $(this);
    const $searchInput = $form.find('input[name="search-string"]');
    let debounceTimer;

    function requestSearchSuggestions(searchTerm) {
      if (!window.csrfToken && typeof window.ensureThrillSession === 'function') {
        window.ensureThrillSession().done(function () {
          requestSearchSuggestions(searchTerm);
        });
        return;
      }

      $.ajax({
        url: '/inc/ajax/search-suggestions.asp',
        type: 'GET',
        data: {
          'search-string': searchTerm,
          'csrf-token': window.csrfToken
        },
        success: function (data) {
          if (hasStructuredSearchPayload(data)) {
            displayStructuredSuggestions($form, data);
            return;
          }

          displaySuggestions($form, data);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error('Error fetching search suggestions:', textStatus, errorThrown);
        }
      });
    }

    $searchInput.on('input', function () {
      clearTimeout(debounceTimer);
      const searchTerm = $(this).val();

      syncDesktopSearchInputs($(this));

      if (searchTerm.length > 2) {
        debounceTimer = setTimeout(function () {
          requestSearchSuggestions(searchTerm);
        }, 300);
      } else {
        if (isNonDesktopViewport()) {
          displayRecentSuggestions($form);
          ensurePopularSearchesLoaded(function () {
            displayRecentSuggestions($form);
          });
        } else {
          closeSuggestions($form);
        }
      }
    });

    $searchInput.on('focus', function () {
      openDesktopSearchPanel($form);
      renderDesktopPanelLists(getDesktopSearchHeader($form));

      if (isNonDesktopViewport()) {
        showMobileSearchPanel($form);
      }

      if ($searchInput.val().trim() === '' && !$form.closest('.desktop-search-panel__bar').length) {
        displayRecentSuggestions($form);
        ensurePopularSearchesLoaded(function () {
          displayRecentSuggestions($form);
        });
      }
    });
  });

  $('.desktop-search-panel__cancel').on('click', function () {
    closeDesktopSearchPanel($(this).closest('.desktop-search-header'));
  });

  $('.search-mobile-header__cancel').on('click', function () {
    const $mobileSearch = $('.search-active').first();
    $mobileSearch.removeClass('is-open show-suggestions').hide();
    closeAllSuggestions();
    syncMobileSearchOverlayState();
  });

  // Mobile expanded search interactions.
  function isNonDesktopViewport() {
    return window.matchMedia('(max-width: 991.98px)').matches;
  }

  let wasNonDesktopViewport = isNonDesktopViewport();

  function syncMobileSearchOverlayState() {
    const isOverlayOpen = isNonDesktopViewport() && ($('.search-active').hasClass('show-suggestions') || $('.desktop-search-header').hasClass('is-open'));
    $('body').toggleClass('mobile-search-overlay-open', isOverlayOpen);
  }

  function ensureMobileSearchVisible() {
    const isNonDesktop = isNonDesktopViewport();
    const $mobileSearch = $('.search-active');

    if (isNonDesktop) {
      if (!wasNonDesktopViewport) {
        $mobileSearch.removeClass('is-open show-suggestions').hide();
        closeDesktopSearchPanel();
      }

      syncMobileSearchOverlayState();
    } else {
      $mobileSearch.removeClass('is-open show-suggestions').hide();
      closeMobileMenuDrawer();
      $('body').removeClass('mobile-search-overlay-open');
    }

    wasNonDesktopViewport = isNonDesktop;
  }

  function showMobileSearchPanel($form) {
    if (!isNonDesktopViewport()) {
      return;
    }

    syncMobileSearchOverlayState();
  }

  ensureMobileSearchVisible();
  $(window).on('resize', ensureMobileSearchVisible);

  $('#searchicon, .js-search-open, .js-mobile-menu-search-trigger').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    openSearchPanel();
  });

  $('.search-active .close').on('click', function (e) {
    if (isNonDesktopViewport()) {
      e.preventDefault();
      $('.search-active').removeClass('is-open show-suggestions').hide();
      closeAllSuggestions();
      syncMobileSearchOverlayState();
      return;
    }

    e.preventDefault();
    $('.search-active').removeClass('is-open show-suggestions').hide();
    closeAllSuggestions();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $('.search-active').removeClass('is-open show-suggestions').hide();

      closeAllSuggestions();
      closeMobileMenuDrawer();
      closeDesktopSearchPanel();
      syncMobileSearchOverlayState();
    }
  });

  // Hide suggestions when clicking outside the active form.
  $(document).on('click', function (e) {
    if (ignoreNextDocumentClick) {
      ignoreNextDocumentClick = false;
      return;
    }

    const $target = $(e.target);

    if (!$target.closest('.js-global-search, .global-search-form-desktop').length) {
      closeAllSuggestions();
    }

    if (isTabletViewport() && !$target.closest('.search-active, .desktop-search-header').length) {
      $('.search-active').removeClass('is-open show-suggestions').hide();
      $('body').removeClass('mobile-search-overlay-open');
    }

    if (!isNonDesktopViewport() && !$target.closest('.search-active, #searchicon, .js-search-open').length) {
      $('.search-active').removeClass('is-open').hide();
    }

    if (!$target.closest('.desktop-search-header, #searchicon, .js-search-open, .mobile-search-trigger').length) {
      closeDesktopSearchPanel();
    }

    if (!$target.closest('.mobile-menu-drawer, .mobile-menu-toggle').length) {
      closeMobileMenuDrawer();
    }

    if (!$target.closest('.more-menu').length) {
      closeMoreMenu();
    }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeMobileMenuDrawer();
      closeMoreMenu();
    }
  });

  // gift finder
  var currentQuestion = 1;
  var totalQuestions = $('.question').length;

  $('#openPanel').click(function (event) {
    event.preventDefault();
    $('#questionPanel').animate({ right: '0px' });
    // Reset the questionnaire to start from first question every time panel opens
    currentQuestion = 1;
    $('.question').hide();
    $('#question1').show();
    $('#backButton').hide();
  });

  $('#nextButton').click(function () {
    // Check if there are more questions
    if (currentQuestion < totalQuestions) {
      // Hide current question
      $('#question' + currentQuestion).hide();

      // Increment current question number
      currentQuestion++;

      // Show next question
      $('#question' + currentQuestion).show();

      // Show back button
      $('#backButton').show();

      // Update progress bar
      var progress = (currentQuestion / totalQuestions) * 100;
      $('#progressBar').css('width', progress + '%');
    } else {
      // If there are no more questions, submit the answers
      $('#questionForm').submit();
    }
  });

  $('#backButton').click(function () {
    // Check if there are previous questions
    if (currentQuestion > 1) {
      // Hide current question
      $('#question' + currentQuestion).hide();

      // Decrement current question number
      currentQuestion--;

      // Show previous question
      $('#question' + currentQuestion).show();

      // If we are back at the first question, hide the back button
      if (currentQuestion === 1) {
        $('#backButton').hide();
      }

      // Update progress bar
      var progress = (currentQuestion / totalQuestions) * 100;
      $('#progressBar').css('width', progress + '%');
    }
  });

  $('#closePanel').click(function () {
    $('#questionPanel').animate({ right: '-100%' }, 500);
  });

  $('.checkbox-wrapper').on('click', function (e) {
    var $checkbox = $(this).find('.right-checkbox');
    if (e.target != $checkbox[0]) {
      $checkbox.trigger('click');
    }
  });

  $('.right-checkbox').on('click', function () {
    var $wrapper = $(this).closest('.checkbox-wrapper');
    var $question = $wrapper.closest('.question');
    $wrapper.toggleClass('highlighted');
    if ($question.data('single') && this.checked) {
      var $siblings = $wrapper.siblings();
      $siblings.find('.right-checkbox').prop('checked', false);
      $siblings.removeClass('highlighted');
      $question.addClass('selected');
    }
    if (!this.checked && $question.find('.right-checkbox:checked').length === 0) {
      $question.removeClass('selected');
    }
  });
});

var rangeSlider = document.getElementById('slider-range');

// Check if slider-range element exists
if (rangeSlider) {
  noUiSlider.create(rangeSlider, {
    start: [150, 800],
    connect: true,
    step: 50,
    range: {
      min: 0,
      max: 1000
    }
  });

  rangeSlider.noUiSlider.on('update', function (values) {
    var value = values.map(v => parseInt(v));
    $('#priceFrom').val('$' + value[0]);
    $('#priceTo').val('$' + value[1]);
  });
}
